import React from 'react'
import './index.sass'

const TextDescription = ({ arrText }) => {
  if (!arrText) return null
  return (
    <div className="additional-info-text">
      {arrText.map((text, ind) => (
        <p className="body-light" key={ind}>
          {text}
        </p>
      ))}
    </div>
  )
}

export default TextDescription
